import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// Ported logic from vektra-client-deprecated/app/index.tsx: route to whichever
// auth step is required next (OTP verification > password change > account
// selection > login), so a partially-authenticated user can never land on a
// guarded page.

export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn, isInitialized, requiresAccountSelection, requiresPasswordChange, requiresOtpVerification } = useAuth() as any;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isInitialized) return;
    if (isLoggedIn) return;

    const target = requiresOtpVerification
      ? '/auth/verify-otp'
      : requiresPasswordChange
        ? '/auth/set-password'
        : requiresAccountSelection
          ? '/auth/select-account'
          : '/auth/login';

    navigate(target, {
      state: { from: location.pathname },
      replace: true
    });
  }, [isLoggedIn, isInitialized, requiresAccountSelection, requiresPasswordChange, requiresOtpVerification, navigate, location.pathname]);

  if (!isInitialized || !isLoggedIn) return null;
  return children;
}
